/**
 * Tiny bridge between thunks (which have no React tree) and the single
 * <LeadIdentityConflictDialog /> mounted under CreateLeadDialogWrapper.
 *
 * A create thunk that gets a 409 `lead_identity_match` awaits
 * `requestIdentityResolution(check)`; the dialog resolves it with
 *   { resolution }            -> retry the POST with identity_resolution
 *   { cancelled: true, ... }  -> abandon the create (optionally with a follow-up navigation done by the dialog)
 * If no dialog is mounted the promise resolves null (treated as cancelled).
 */
let handler = null;

export function registerIdentityConflictHandler(fn) {
    handler = fn;
    return () => {
        if (handler === fn) handler = null;
    };
}

export function requestIdentityResolution(check) {
    if (!handler) return Promise.resolve(null);
    return handler(check);
}
